import { createContext } from 'react';
import { BondSameIssuerResponse } from '../../../type';

export const sameIssuerCurrencyContext = createContext<BondSameIssuerResponse['C_CURRENCY.CODE']>('EUR');
